import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../input/Input";
import Dropdown from "../../input/Dropdown";
import { FORMS, MODULES } from "../../../const";

const FORM = FORMS.QUICK_REQUEST.SUMMARY.form;

const QuickRequestSummary = forwardRef(
  ({ dropdown, editMode, isLoading }, ref) => {
    const dispatch = useDispatch();
    const viewOnlyMode = useSelector((state) => state.request.viewOnlyMode);
    const reqCbm = useSelector((state) => state.request.reqCbm);
    const reqQty = useSelector((state) => state.request.reqQty);
    const currentValuesSummery = useSelector(
      (state) => state.request.currentValues.requestSummary
    );
    const scheduleResult = useMemo(
      () => currentValuesSummery?.requestSchedulerResponse ?? {},
      []
    );
    const [requestSummary, setRequestSummary] = useState(
      editMode
        ? currentValuesSummery
        : {
            reqQty: null,
            reqUom: null,
            reqCbm: null,
            reqCbmUom: null,
            reqTotalKm: null,
            reqApprovedBy: "",
            reqRemarks: "",
            reqApprovedDate: "",
            reqApprovedDateFormatted: "",
            reqStatus: 1,
          }
    );
    const [toDateGap, setToDateGap] = useState(null);

    const today = new Date().toISOString().split("T")[0];
    const dateGap = toDateGap || "";
    const [requestScheduler, setRequestScheduler] = useState(
      editMode === true && scheduleResult !== null
        ? {
            ...scheduleResult,
            // rscFrom:scheduleResult.rscFrom.includes("T") ? scheduleResult.rscFrom.split("T")[0] : scheduleResult.rscFrom,
            // rscTo:scheduleResult.rscTo.includes("T") ? scheduleResult.rscTo.split("T")[0] : scheduleResult.rscTo,
            rscFrom: scheduleResult.rscFrom?.includes("T")
              ? scheduleResult.rscFrom.split("T")[0]
              : scheduleResult.rscFrom,
            rscTo: scheduleResult.rscTo?.includes("T")
              ? scheduleResult.rscTo.split("T")[0]
              : scheduleResult.rscTo,
          }
        : {
            rscReferance: "",
            rscComId: 1,
            rscScheduleType: null,
            rscFrom: "",
            rscTo: "",
            rscTimeEnable: false,
            rscStartTime: "09:00",
            rscEndTime: "",
            rscFrequency: 1,
            rscUom: null,
            rscSun: null,
            rscMon: null,
            rscTue: null,
            rscWed: null,
            rscThu: null,
            rscFri: null,
            rscSat: null,
            rscDescription: "",
            rscStatus: 2,
            rscActive: 1,
            rscScheduleTypeName: "",
            minToDate: today,
          }
    );

    const [currentErrors, setCurrentErrors] = useState({});
    const [requestCurrentErrors, setRequestCurrentErrors] = useState({});
    const [selectedDays, setSelectedDays] = useState([]);
    const [editVal, setEditVal] = useState([]);

    console.log("selected days", selectedDays);

    const errors = useSelector((state) => state.request.requestSummaryErrors);
    const requestErrors = useSelector(
      (state) => state.error.requestSchedulerErrors
    );

    console.log("requestErrors", requestErrors);
    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    useEffect(() => {
      setRequestCurrentErrors(requestErrors.requestSchedulerErrors);
    }, [requestErrors]);

    useEffect(() => {
      setRequestSummary((prevState) => ({
        ...prevState,
        reqCbm: reqCbm,
        reqQty: reqQty,
      }));
    }, [reqCbm, reqQty]);

    useEffect(() => {
      const sunday = 0;
      const monday = 1;
      const tuesday = 2;
      const wednesday = 3;
      const thursday = 4;
      const friday = 5;
      const saturday = 6;
      setRequestScheduler((prevState) => ({
        ...prevState,
        rscSun: selectedDays.includes(sunday),
        rscMon: selectedDays.includes(monday),
        rscTue: selectedDays.includes(tuesday),
        rscWed: selectedDays.includes(wednesday),
        rscThu: selectedDays.includes(thursday),
        rscFri: selectedDays.includes(friday),
        rscSat: selectedDays.includes(saturday),
      }));
    }, [selectedDays]);

    useEffect(() => {
      setEditVal(scheduleResult);
    }, [editMode, scheduleResult]);

    useImperativeHandle(ref, () => ({
      getData: () => requestSummary,
      getRequestSchedulerData: () => requestScheduler,
    }));

    return (
      <div>
        <form className="ui form">
          <div className="ui segment">
            <h4 className="ui dividing header">Summary Information</h4>
            <div className="field">
              <div className="two fields ">
                <Input
                  required={true}
                  label="CBM"
                  error={currentErrors.reqCbm}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="req_cbm"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { reqCbm: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="cbm"
                  readOnly={true}
                  value={requestSummary?.reqCbm}
                />
                <Input
                  label="QTY"
                  error={currentErrors.reqQty}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="req_qty"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { reqQty: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="remarks"
                  readOnly
                  value={requestSummary?.reqQty}
                />
              </div>
              <div className="two fields ">
                <Dropdown
                  readOnly={viewOnlyMode}
                  label="UOM"
                  error={currentErrors.reqUom}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="req_uom"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { reqUom: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.uomTypeOptions}
                  placeholder="UOM"
                  value={requestSummary?.reqUom}
                  style={{ height: "5px" }}
                  onChange={(e, data) => {
                    setRequestSummary((prevState) => ({
                      ...prevState,
                      reqUom: data.value,
                    }));
                  }}
                />
                <Input
                  readOnly={viewOnlyMode}
                  label="Total KM"
                  error={currentErrors.reqTotalKm}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="req_tota_km"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { reqTotalKm: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="total_km"
                  value={requestSummary?.reqTotalKm}
                  onChange={(e) => {
                    setRequestSummary((prevState) => ({
                      ...prevState,
                      reqTotalKm: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields ">
                <Input
                  readOnly={viewOnlyMode}
                  label="Creator Remark"
                  error={currentErrors.reqRemarks}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="req_remarks"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { reqRemarks: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="remarks"
                  value={requestSummary?.reqRemarks}
                  onChange={(e) => {
                    setRequestSummary((prevState) => ({
                      ...prevState,
                      reqRemarks: e.target.value,
                    }));
                  }}
                />
                <Dropdown
                  label="Status"
                  error={currentErrors.reqStatus}
                  form={FORM}
                  module={MODULES.Transaction}
                  field="req_status"
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { reqStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={dropdown.statusTypeOptions}
                  style={{ height: "5px" }}
                  value={requestSummary?.reqStatus}
                  readOnly
                />
              </div>
              {editMode && (
                <div className="two fields ">
                  <Input
                    label="Approved By"
                    error={currentErrors.reqApprovedBy}
                    form={FORM}
                    module={MODULES.Transaction}
                    field="req_approved_by"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { reqApprovedBy: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    name="approved_by"
                    value={requestSummary?.reqApprovedBy}
                    readOnly
                  />
                  <Input
                    label="Approved Date Time"
                    error={currentErrors.reqApprovedDateFormatted}
                    form={FORM}
                    module={MODULES.Transaction}
                    field="req_approved_date"
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { reqApprovedDateFormatted: _, ...rest } =
                          prevState;
                        return rest;
                      })
                    }
                    name="approved_date"
                    value={requestSummary?.reqApprovedDateFormatted}
                    readOnly
                  />
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    );
  }
);

export default QuickRequestSummary;
